import { Navigate } from "react-router-dom";
import { usePublicMeta } from "@/lib/publicMeta";
import { useAuth } from "@/context/AuthContext";
import PublicHome from "@/pages/PublicHome";
import { useTenant } from "@/context/TenantContext";
import { Spinner } from "@/components/Bits";

/**
 * Where "/" and any unknown path go. The owner starts at their platform
 * overview; client agents go straight to their own dashboard.
 */
export default function Landing() {
  const { user, loading } = useAuth();
  const { tenantId, loading: tenantLoading } = useTenant();
  const meta = usePublicMeta();

  if (loading || user === null || tenantLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <Spinner className="w-6 h-6" />
      </div>
    );
  }
  if (!user) {
    return meta.public?.landing?.enabled ? <PublicHome /> : <Navigate to="/login" replace />;
  }
  if (user.must_change_password) return <Navigate to="/set-password" replace />;
  if (user.role === "owner") return <Navigate to="/overview" replace />;
  if (!tenantId) return <Navigate to="/login" replace />;
  return <Navigate to="/dashboard" replace />;
}
